import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";

/**
 * 从数组创建一个 EntityCollection
 */
export var createEntityCollection = function createEntityCollection(entityList, keySelector) {
  return {
    list: entityList.map(function (t) {
      return keySelector(t);
    }),
    entities: entityList.reduce(function (ret, item) {
      ret[keySelector(item)] = item;
      return ret;
    }, {})
  };
};
/**
 * 将 EntityCollection 集合转换为普通数组
 */

export var convertToEntityList = function convertToEntityList(collection) {
  return collection.list.map(function (key) {
    return collection.entities[key];
  });
};